<template>
  <v-card outlined>
    <v-system-bar class="FormTemplatesFormCellContainerBar flex-wrap flex-lg-nowrap py-1" height="auto">
      <div
        class="text-truncate flex-shrink-1 flex-grow-1 flex-lg-grow-0"
        v-text="title"
      />

      <div class="flex-grow-1 order-1 order-lg-0">
        <slot name="header" />
      </div>

      <div class="flex-shrink-0">
        <BTooltipButton
          v-for="item in buttonList"
          :key="item.action"
          :tooltip="item.tooltip"
          :icon="item.icon"
          :skeleton="skeleton"
          depressed
          top
          x-small
          @click="$emit(item.action)"
        />

        <BTooltipButton
          :tooltip="hint.tooltip"
          :icon="hint.icon"
          :skeleton="skeleton"
          depressed
          top
          x-small
          @click="toggleHint"
        />

        <BTooltipButton
          :tooltip="description.tooltip"
          :icon="description.icon"
          :skeleton="skeleton"
          depressed
          top
          x-small
          @click="toggleDescription"
        />

        <BTooltipButton
          :tooltip="size.tooltip"
          :icon="size.icon"
          :skeleton="skeleton"
          depressed
          top
          x-small
          @click="toggleSize"
        />
      </div>
    </v-system-bar>

    <section v-if="size.active" class="pa-2">
      <slot />

      <BTextField
        v-if="form.customColumnWidth && !vertical"
        v-model="form.width"
        validate="required"
        label="Ширина столбца в px"
        :skeleton="skeleton"
        type="number"
        name="cell-width"
        class="mt-2"
      />

      <BTextarea
        v-if="withDescription"
        v-model="form.description"
        label="Подсказка"
        :skeleton="skeleton"
        :rows="1"
        name="cell-description"
        class="mt-2"
      />

      <BTextarea
        v-if="withHint"
        v-model="form.hint"
        label="Описание"
        :skeleton="skeleton"
        :rows="3"
        name="hint"
        class="mt-2"
      />
    </section>
  </v-card>
</template>

<script>
import {
  SORTABLE_POSITIONS_DOWN,
  SORTABLE_POSITIONS_UP,
  COPY,
  DELETE,
} from '@/helpers/enums/table-actions'
import {
  HINT_SHOW,
  HINT_HIDE,
} from '@/views/FormTemplates/table-actions'
import BTooltipButton from '@/components/common/BTooltipButton.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BTextarea from '@/components/forms/BTextarea.vue'


const MINIMIZE = {
  tooltip: 'Развернуть',
  icon: 'mdi-window-minimize',
  active: false,
}

const MAXIMIZE = {
  tooltip: 'Свернуть',
  icon: 'mdi-window-maximize',
  active: true,
}

const DESCRIPTION_ADD = {
  tooltip: 'Показать подсказку',
  icon: 'mdi-message-alert-outline',
}

const DESCRIPTION_REMOVE = {
  tooltip: 'Скрыть подсказку',
  icon: 'mdi-message-alert',
}

export default {
  name: 'FormTemplatesFormCellContainer',
  components: {
    BTooltipButton,
    BTextarea,
    BTextField,
  },
  props: {
    skeleton: Boolean,
    upable: Boolean,
    downable: Boolean,
    vertical: Boolean,
    form: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    size: MAXIMIZE,
    copy: COPY,
    description: DESCRIPTION_ADD,
    hint: HINT_SHOW,
  }),
  computed: {
    title() {
      const { form } = this
      const prefix = form.code
      const title = !form.name ? prefix : `${prefix} (${form.name})`
      return !form.description ? title : `${title} - ${form.description}`
    },
    buttonList() {
      return [
        this.upable && SORTABLE_POSITIONS_UP,
        this.downable && SORTABLE_POSITIONS_DOWN,
        COPY,
        DELETE,
      ].filter(Boolean)
    },
    withDescription() {
      return this.description === DESCRIPTION_REMOVE
    },
    withHint() {
      return this.hint === HINT_HIDE
    },
  },
  created() {
    if (this.form?.hint) this.hint = HINT_HIDE
  },
  methods: {
    toggleSize() {
      this.size = this.size === MINIMIZE ? MAXIMIZE : MINIMIZE
    },
    toggleDescription() {
      this.description = this.description === DESCRIPTION_ADD
        ? DESCRIPTION_REMOVE
        : DESCRIPTION_ADD
    },
    toggleHint() {
      this.hint = this.hint === HINT_SHOW ? HINT_HIDE : HINT_SHOW
    },
  },
}
</script>

<style lang="scss">
.FormTemplatesFormCellContainerBar {
  gap: 10px;

  > div:nth-child(1) {
    flex-basis: 50%;

    @media (min-width: breakpoint-min(lg)) {
      flex-basis: auto;
    }
  }
}
</style>
